module.exports = __webpack_public_path__ + "static/img/com1_3.70ce427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com1_3.jpg
// module id = J2cH
// module chunks = 1